<template>
    <picker :range="options" :value="value" :title="title" @change="handleChange">{{value || placeholder}}</picker>
</template>

<script>
    import mixins from "./mixins";
    export default {
        name: "clSelect",
        mixins: [mixins],
        props: {
            title: {
                type: String,
                default: '选择时间'
            },
            value: String,
            placeholder: String,
            options: Array
        },
        methods: {
            handleChange(value) {
                this.$emit("input", value);
                this.notifyCheck();
            }
        }
    }
</script>

<style scoped>

</style>
